import { queryValidators } from "../QueryValidator";
export function getQueryValidator(type) {
    return typeof type !== "undefined" && typeof queryValidators[type] === "function" ?
        queryValidators[type] :
        queryValidators.default;
}
//# sourceMappingURL=GetQueryValidator.js.map